import { theme, type ThemeConfig } from 'antd';
import type { ResolvedTheme } from './~reusables/contexts/ThemeModeContext';

export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: '#3946f1',
    // Links default to antd's #1677ff, a second blue next to the brand colour
    colorLink: '#3946f1',
    colorLinkHover: '#5c67f4',
    colorLinkActive: '#2733c9',
    fontFamily:
      "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
  },
  components: {
    // Flat cards to match the top bar; the border comes from App.globalCSS.
    Card: {
      borderRadiusLG: 12,
      headerFontSize: 15,
    },
  },
};

// Ant Design's dark algorithm, with surfaces, borders and text matching the
// dark --layout-* and --nav-* colours in App.globalCSS
const antdDarkTheme: ThemeConfig = {
  ...antdTheme,
  algorithm: theme.darkAlgorithm,
  token: {
    ...antdTheme.token,
    colorBgLayout: '#1a1a1a',
    colorBgContainer: '#2a2a2a',
    colorBgElevated: '#2a2a2a',
    colorBorder: '#444444',
    colorBorderSecondary: '#333333',
    colorText: '#e0e0e0',
    colorTextSecondary: '#b0b0b0',
    colorTextTertiary: '#8a8a94',
    colorTextQuaternary: '#6f6f78',
    // The brand blue is too dark to read as text on dark surfaces
    colorLink: '#9aa1ff',
    colorLinkHover: '#b7bcff',
    colorLinkActive: '#7c84ff',
  },
};

export const getAntdTheme = (resolvedTheme: ResolvedTheme): ThemeConfig =>
  resolvedTheme === 'dark' ? antdDarkTheme : antdTheme;
